import { Component } from '@angular/core';

@Component({
  selector: 'dentr-santa-sleigh',
  templateUrl: './santa-sleigh.component.html',
  styleUrls: ['./santa-sleigh.component.scss'],
  standalone: true,
})
export class SantaSleighComponent {}
